export default __webpack_public_path__ + "static/media/merchant.28045eec.svg";